const rutasProyectoTorre2 = [
  // torre_2
  // torre_2_p1
  // torre_2_pisos
  // torre_2_ventanas
  // torre_2_balconesMuros
  // torre_2_balconesBarandas * tiene Alpha

  /// Modelos


  {
    name: "modelo_torre_2",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 02_FL.gltf",
  },
  {
    name: "modelo_torre_2_p1",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 02_P1_FL.gltf",
  },
  {
    name: "modelo_torre_2_pisos",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 02_PISOS Y CUARTOS CUBIERTA_FL.gltf",
  },
  {
    name: "modelo_torre_2_ventanas",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 02_VENTANAS_FL.gltf",
  },
  {
    name: "modelo_torre_2_balconesMuros",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 02_BALCONES_MUROS_FL.gltf",
  },
  {
    name: "modelo_torre_2_balconesBarandas",
    type: "gltfModel",
    path: "modelos/proyecto/TORRE 02_BALCONES_BARANDAS_FL.gltf",
  },

  ///Texturas  
  /*{
    name: "text_ejemplo",
    type: "texture",
    path: "texturas/proyecto/ejemplo.webp"
  },*/

  {
    name: "text_torre_2",
    type: "texture",
    path: "texturas/proyecto/TORRE 02_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_p1",
    type: "texture",
    path: "texturas/proyecto/TORRE 02_P1_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_pisos",
    type: "texture",
    path: "texturas/proyecto/TORRE 02_PISOS Y CUARTOS CUBIERTA_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_ventanas",
    type: "texture",
    path: "texturas/proyecto/TORRE 02_VENTANAS_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_balconesMuros",
    type: "texture",
    path: "texturas/proyecto/TORRE 02_BALCONES_MUROS_FL_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_balconesBarandas",
    type: "texture",
    path: "texturas/proyecto/TORRE 02_BALCONES_BARANDAS_FL_Corona_Diffuse1.webp"
  },
  {
    name: "text_torre_2_balconesBarandas_alpha",
    type: "texture",
    path: "texturas/proyecto/TORRE 02_BALCONES_BARANDAS_FL_Corona_Diffuse.webp"
  },
];

export default rutasProyectoTorre2;
